import http from "@/settings/apiSettings"

class DOC_DocumenteDataService {
    save(data: any): Promise<any> {
        return http.clientDocumenteOdata.post("/DOC_Documente", data);
    }
    update(id: string, data: any): Promise<any> {
        return http.clientDocumenteOdata.put(`/DOC_Documente/${id}`, data);
    }
}
export default new DOC_DocumenteDataService();
